import './ContentSection.scss'
import { Route, Routes, useLocation } from "react-router-dom";
import TitleBackground from '../Assets/TitleBackground.png'
import AboutUs from './AboutUs'
import { useEffect, useState } from 'react';
import HomePage from './HomePage';
import ServicesPage from './ServicesPage';
import ContactUsPage from './ContactUsPage';
import GalleryPage from './Gallery/GalleryPage';
import CareersPage from './CareersPage';

const ContentSection = () => {
  const [Current, setCurrent] = useState('')
  const {pathname} = useLocation()
  const Home = pathname.includes("home");
  const Aboutus = pathname.includes("about-us");
  const Services = pathname.includes("services");
  const Careers = pathname.includes("careers");
  const Gallery = pathname.includes("gallery");
  const ContactUs = pathname.includes("contact-us");
  useEffect(() => {
    setCurrent(
      Home ? 'Home' :
      Aboutus ? 'About Us' :
      Services ? 'Services' :
      Careers ? 'Careers' :
      Gallery ? 'Gallery' :
      ContactUs ? 'Contact us' : 'Home'
    )
  },[pathname])

  return (
    <main className='ContentSection'>
      {(Aboutus || Services || Careers || Gallery || ContactUs) &&
        <section className='TitleBack'>
          <img src={TitleBackground} alt='Title background image' loading='lazy' className='TitleBackground'/>
          <span>{Current}</span>
        </section>
      }
      <Routes>
        <Route path='/about-us' exact element={<AboutUs/>}/>
        <Route path='/home' exact element={<HomePage/>}/>
        <Route path='/' exact element={<HomePage/>}/>
        <Route path='/services' exact element={<ServicesPage/>}/>
        <Route path='/services/:servicetype' exact element={<ServicesPage/>}/>
        <Route path='/contact-us' exact element={<ContactUsPage/>}/>
        <Route path='/careers' exact element={<CareersPage/>}/>
        <Route path='/gallery' exact element={<GalleryPage/>}/>
      </Routes>
    </main>
  )
}

export default ContentSection